<div class="modal" *ngIf="showModal">
  <div
    class="mask inactivity-modal"
    (click)="doRefresh()"
    [ngClass]="{ 'inactivity-modal--closing': isModalClosing }"
  >
    <div class="inactivity-modal__container">
      <div class="inactivity-modal__title">
        Hemos notado inactividad en tu sesión, y ésta expirará en:
      </div>
      <div class="inactivity-modal__counter">{{ timeLeft }}</div>
      <div class="inactivity-modal__question">¿Qué deseas hacer?</div>
      <div class="inactivity-modal__actions">
        <button
          class="button button--transparent button--small"
          (click)="doLogout()"
        >
          Cerrar sesión
        </button>
        <button class="button button--dark button--small" (click)="doRefresh()">
          Mantener sesión
        </button>
      </div>
    </div>
  </div>
</div>
